/** Diagnostic réseau : quels chemins vers l'extérieur ce navigateur a-t-il trouvés ? */

export interface CandidateSummary {
  readonly host: number;
  readonly srflx: number;
  readonly relay: number;
}

export function summarizeCandidates(candidates: readonly string[]): CandidateSummary {
  const count = { host: 0, srflx: 0, relay: 0 };
  for (const c of candidates) {
    const typ = / typ (host|srflx|relay)\b/.exec(c)?.[1] as keyof typeof count | undefined;
    if (typ) count[typ]++;
  }
  return count;
}

export interface NetworkVerdict {
  readonly level: 'ok' | 'warn' | 'error';
  readonly turn: boolean;
  readonly message: string;
}

export function networkVerdict(s: CandidateSummary): NetworkVerdict {
  if (s.relay > 0)
    return {
      level: 'ok',
      turn: true,
      message: 'Relais TURN disponible : la partie devrait passer même sur un réseau fermé.',
    };
  if (s.srflx > 0)
    return {
      level: 'warn',
      turn: false,
      message:
        'Connexion directe possible (STUN), sans relais TURN : ça passe avec la plupart des réseaux, pas tous.',
    };
  return {
    level: 'error',
    turn: false,
    message:
      'Aucun chemin vers l’extérieur : réseau très fermé (entreprise ?) ou serveurs STUN/TURN injoignables.',
  };
}
